/**
 * @description ホテルコード、プランコードのリンク設定
 */

import { setid } from './setid';

export const setWpReserveLink = () => {
  const target = $('.wp-reserve-link');
  if (!target.length) return;

  const plancode = target.data('plancode');
  const link = `https://reserve.kanponoyado.japanpost.jp/rsvsearch/rsvsearchplan.aspx?`;
  const hotelname = ['ichinoseki', 'shiobara', 'okunikko', 'kitsuregawa', 'oarai', 'nagatoroyorii', 'itako', 'ome', 'kujukuri', 'kamogawa', 'fukui', 'atami', 'atamiannex', 'yaizu', 'izukougen', 'chitamihama', 'toba', 'hikone', 'arima', 'ako', 'nara', 'yamatoheguri', 'awajishima', 'tondabayashi', 'kiitanabe', 'kanonji', 'setouchihikari', 'kochi', 'genkainada', 'beppu', 'yanagawa', 'aso'];
  const hotelcode = ['31060', '32060', '', '32080', '32020', '32140', '32040', '33020', '32180', '32160', '34060', '33120', '33130', '34080', '33160', '34140', '34200', '35020', '35160', '35180', '35100', '35080', '35200', '35080', '35140', '36120', '36080', '36200', '37020', '', '37040', '37140'];
  const hotelsCode = hotelname.map((v, i) => ({ 'name': v, 'code': hotelcode[i] }));

  setid().then(() => {
    const targetHotel = hotelsCode.filter((v) => {
      return v['name'] === sessionStorage.getItem('name');
    });
    target.attr('href', `${link}o_cd=${targetHotel[0].code}&p_cd=${plancode}`);
  });
};
